import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getCompanyProfileDetailsApi, updatePersonalDetailsApi } from "../../API/API";

function* getCompanyProfileDetailsSaga(action) {

    try {
        // const {limit, skip, status,search} = action.payload;
        const response = yield call(() => getCompanyProfileDetailsApi());
        yield put({ type: types.GET_COMPANYPROFILEDETAILS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.GET_COMPANYPROFILEDETAILS_FAILURE, error });
    }
}

function* updateCompanyProfileLinkedAccoutsSaga(params) {

    try {
        const response = yield call(() => updatePersonalDetailsApi(params.payload.params));
        yield put({ type: types.UPDATE_COMPANYPROFILELINKEDACCOUNTS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.UPDATE_COMPANYPROFILELINKEDACCOUNTS_FAILURE, error });
    }
}

export function* watchGetCompanyProfileDetailsSaga() {
    yield takeEvery(types.GET_COMPANYPROFILEDETAILS_REQUESTED, getCompanyProfileDetailsSaga);
}

export function* watchUpdateCompanyProfileLinkedAccoutsSaga() {
    yield takeEvery(types.UPDATE_COMPANYPROFILELINKEDACCOUNTS_REQUESTED, updateCompanyProfileLinkedAccoutsSaga);
} 